<template>
  <AsideButtonActive
    v-if="!subitems.length"
    :route="route"
  />
  <AsideButtonWithSubmenu
    v-else
    :route="route"
    :subitems="subitems"
    :active-group="activeGroup"
    @change-active-group="$emit('change-active-group', $event)"
  />
</template>

<script>
import AsideButtonActive from './aside-menu-button-active';
import AsideButtonWithSubmenu from './aside-menu-button-with-submenu';

export default {
  props: {
    route: {
      type: Object,
      default: null,
      required: true,
    },
    subitems: {
      type: Array,
      default: () => [],
      required: false,
    },
    activeGroup: {
      type: String,
      default: '',
    },
  },
  components: { AsideButtonActive, AsideButtonWithSubmenu },
};
</script>
